export default __webpack_public_path__ + "static/media/vegan.5babe198.png";